const configurationManager = require('../config/configurationManager.js');
const stringUtil = require('../string/stringUtil.js');
const displaySettingsUtils = require('../domain/settings/displaySettingsUtils.js');

module.exports.systemTheme = null;

module.exports.getLoadingViewLogo = function()
{
    return `app/pos/theme/${configurationManager.getConfig().posThemeVersion}/loading_logo.png`
}

module.exports.getResolvedLogo = function()
{
    var systemLogo = `app/pos/theme/${configurationManager.getConfig().posThemeVersion}/flipdish.png`;
    /*
        TODO: We need to have a separate file in azure to indicate overrides for logo image and button icons if required.
    */
    return systemLogo;
}

module.exports.getResolvedPages = function()
{
    let themeLayout = displaySettingsUtils.getDisplayLayoutTheme();
    if (themeLayout != null)
        return themeLayout.pages;

    return this.systemTheme.pages;
}

module.exports.getResolvedDockBar = function()
{
    let themeLayout = displaySettingsUtils.getDisplayLayoutTheme();
    if (themeLayout != null)
        return themeLayout.dockBar;

    return this.systemTheme.dockBar;
}

module.exports.getResolvedButton = function(buttonId)
{
    return this.systemTheme.buttons.find(b => stringUtil.areStringSame(b, buttonId));
}

module.exports.getPublicId = function(imageName)
{
    return `app/pos/theme/${configurationManager.getConfig().posThemeVersion}/${imageName}`
}